export default {
  getEstimation: (state) => state.estimation,
};
